/* ============================================================================
   KIVORA SYSTEM
   Custom elements only. Every feature degrades to working HTML without JS.
   No framework, no dependencies, no scroll parallax.
   ========================================================================== */
(function () {
  'use strict';
  if (typeof window.customElements === 'undefined') { return; }

  var reduce = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* Motion is opt-in at the document level so CSS can gate every animation. */
  if (!reduce) { document.documentElement.classList.add('is-motion'); }

  function define(name, proto, extend) {
    if (window.customElements.get(name)) { return; }
    var C = function () { return Reflect.construct(HTMLElement, [], C); };
    C.prototype = Object.create(HTMLElement.prototype);
    C.prototype.constructor = C;
    Object.setPrototypeOf(C, HTMLElement);
    for (var k in proto) { if (Object.prototype.hasOwnProperty.call(proto, k)) { C.prototype[k] = proto[k]; } }
    window.customElements.define(name, C);
    return C;
  }

  function money(cents, format) {
    var n = (cents / 100).toFixed(2);
    /* v6.14: el placeholder puede ser amount_with_comma_separator,
       amount_no_decimals, etc. La regex estricta imprimia el placeholder
       literal en cuanto el formato no fuera exactamente {{amount}}. */
    return (format || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }

  /* v6.9.5: escape de entidades para texto que se concatena a HTML. Antes se
     BORRABAN los caracteres < > & " (un titulo con "&" perdia el ampersand);
     ahora se escapan y el texto se muestra integro y seguro. */
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---------------------------------------------------------------- reveal */
  /* The single entrance mechanism for the whole store. Every animated element
     anywhere carries one of four classes and is revealed here; no section runs
     its own observer, and an element is unobserved the moment it has arrived. */
  var REVEAL = '.kv-r, .kv-line, .kv-w, .kv-x';
  var HIDDEN = '.kv-r:not(.is-in), .kv-line:not(.is-in), .kv-w:not(.is-in), .kv-x:not(.is-in)';
  var design = !!(window.Shopify && window.Shopify.designMode);

  function revealAll(root) {
    var all = (root || document).querySelectorAll(HIDDEN);
    for (var i = 0; i < all.length; i++) { all[i].classList.add('is-in'); }
  }

  define('kv-reveal', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;

      /* Inside the theme editor sections are torn down and rebuilt constantly.
         An observer that misses one of those rebuilds leaves the merchant
         looking at an empty section, so the editor simply gets everything. */
      if (reduce || design || !('IntersectionObserver' in window)) {
        revealAll(this);
        return;
      }
      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) { continue; }
          entries[i].target.classList.add('is-in');
          if (self._io) { self._io.unobserve(entries[i].target); }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

      /* Anything already above the fold plays immediately, not on scroll. */
      /* v6.14: dos pasadas — primero TODAS las lecturas de layout, luego
         todas las escrituras. Alternarlas forzaba un recalculo sincrono de
         layout por elemento (decenas en portada) justo antes del primer
         pintado. */
      var targets = this.querySelectorAll(REVEAL);
      var vh = window.innerHeight || 800;
      var tops = [];
      for (var i = 0; i < targets.length; i++) { tops.push(targets[i].getBoundingClientRect().top); }
      for (i = 0; i < targets.length; i++) {
        if (tops[i] < vh * 0.92) { targets[i].classList.add('is-in'); }
        else { this._io.observe(targets[i]); }
      }

      /* Safety net. Content must never stay invisible because an observer
         failed to fire. Anything near the fold is shown well inside a second. */
      this._net = window.setTimeout(function () {
        var left = self.querySelectorAll(HIDDEN);
        var vh2 = (window.innerHeight || 800) * 1.5;
        var tops2 = [];
        for (var k = 0; k < left.length; k++) { tops2.push(left[k].getBoundingClientRect().top); }
        for (k = 0; k < left.length; k++) {
          if (tops2[k] < vh2) { left[k].classList.add('is-in'); }
        }
      }, 900);

    },
    disconnectedCallback: function () {
      if (this._io) { this._io.disconnect(); }
      if (this._net) { window.clearTimeout(this._net); }
      this._io = null; this._net = null; this._on = false;
    }
  });

  /* The editor also selects and reloads individual blocks, which can re-insert
     markup after the section's observer has already been set up. */
  if (design) {
    document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) { revealAll(e.target); });
    document.addEventListener('shopify:section:select', function (e) { revealAll(e.target); });
  }

  /* ---------------------------------------------------------------- drawer */
  var openDrawer = null;
  function closeAny() {
    if (!openDrawer) { return; }
    openDrawer.close();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAny(); }
  });

  define('kv-drawer', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      this._panel = this.querySelector('[data-panel]');
      this._scrim = this.querySelector('[data-scrim]');
      this._last = null;

      this.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-close]')) { self.close(); }
      });
      if (this._scrim) { this._scrim.addEventListener('click', function () { self.close(); }); }

      var id = this.getAttribute('id');
      this._openers = document.querySelectorAll('[data-drawer-open="' + id + '"]');
      this._bound = function (e) { e.preventDefault(); self.open(); };
      for (var i = 0; i < this._openers.length; i++) {
        this._openers[i].addEventListener('click', this._bound);
      }
      this._trap = function (e) {
        if (e.key !== 'Tab' || !self._panel) { return; }
        var f = self._panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])');
        if (!f.length) { return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
    },
    open: function () {
      if (openDrawer && openDrawer !== this) { openDrawer.close(); }
      this._last = document.activeElement;
      this.setAttribute('open', '');
      if (this._panel) { this._panel.classList.add('is-open'); }
      if (this._scrim) { this._scrim.classList.add('is-open'); }
      document.body.classList.add('kv-locked');
      document.addEventListener('keydown', this._trap);
      openDrawer = this;
      /* v6.9.5: los botones que abren este cajon reflejan su estado. */
      if (this._openers) {
        for (var i = 0; i < this._openers.length; i++) { this._openers[i].setAttribute('aria-expanded', 'true'); }
      }
      var focus = this.querySelector('[data-autofocus]') || this.querySelector('[data-close]');
      if (focus) { window.setTimeout(function () { focus.focus(); }, 120); }
    },
    close: function () {
      this.removeAttribute('open');
      if (this._panel) { this._panel.classList.remove('is-open'); }
      if (this._scrim) { this._scrim.classList.remove('is-open'); }
      document.body.classList.remove('kv-locked');
      document.removeEventListener('keydown', this._trap);
      if (openDrawer === this) { openDrawer = null; }
      /* v6.9.5: los botones que abren este cajon reflejan su estado. */
      if (this._openers) {
        for (var i = 0; i < this._openers.length; i++) { this._openers[i].setAttribute('aria-expanded', 'false'); }
      }
      if (this._last && this._last.focus) { this._last.focus(); }
    },
    disconnectedCallback: function () {
      document.body.classList.remove('kv-locked');
      document.removeEventListener('keydown', this._trap);
      if (openDrawer === this) { openDrawer = null; }
      /* v6.9.5: se retiran los listeners de click anadidos a los botones de
         apertura, usando la misma referencia bound con la que se anadieron. */
      if (this._openers && this._bound) {
        for (var i = 0; i < this._openers.length; i++) { this._openers[i].removeEventListener('click', this._bound); }
      }
      this._on = false;
    }
  });

  /* ------------------------------------------------------------ mega menu */
  /* v6.9.5: eliminado el componente kv-mega. Desde v6.9.0 el menu de
     escritorio vive entero en sections/header.liquid con su propio marcado
     [data-kv-toggle]/[data-kv-panel] y su propio script: ninguna plantilla
     emite ya <kv-mega> (comprobado en el tema), asi que este bloque era
     codigo muerto y ademas registraba un keydown en document que nunca se
     retiraba. */

  /* ------------------------------------------------------------ sticky hdr */
  define('kv-header', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
      if (this.parentNode) { this.parentNode.insertBefore(sentinel, this); }
      if (!('IntersectionObserver' in window)) { return; }
      this._io = new IntersectionObserver(function (e) {
        self.classList.toggle('is-stuck', !e[0].isIntersecting);
      }, { threshold: 0 });
      this._io.observe(sentinel);
      this._sentinel = sentinel;
    },
    disconnectedCallback: function () {
      if (this._io) { this._io.disconnect(); }
      if (this._sentinel && this._sentinel.parentNode) { this._sentinel.parentNode.removeChild(this._sentinel); }
      this._on = false;
    }
  });

  /* ------------------------------------------------------------- quantity */
  define('kv-qty', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var input = this.querySelector('input');
      if (!input) { return; }
      this.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[data-step]');
        if (!b) { return; }
        e.preventDefault();
        var step = parseInt(b.getAttribute('data-step'), 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10);
        if (isNaN(min)) { min = 0; }
        var next = (parseInt(input.value, 10) || 0) + step;
        if (next < min) { next = min; }
        /* v6.9.5: se respeta tambien el maximo declarado en el input. */
        var max = parseInt(input.getAttribute('max'), 10);
        if (!isNaN(max) && next > max) { next = max; }
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    },
    disconnectedCallback: function () { this._on = false; }
  });

  /* -------------------------------------------------------------- gallery */
  define('kv-gallery', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      this._slides = this.querySelectorAll('[data-slide]');
      this._thumbs = this.querySelectorAll('[data-thumb]');
      if (this._thumbs.length < 2) { return; }
      this.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-thumb]');
        if (!t) { return; }
        e.preventDefault();
        self.show(t.getAttribute('data-thumb'));
      });
      this.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') { return; }
        var t = e.target.closest && e.target.closest('[data-thumb]');
        if (!t) { return; }
        e.preventDefault();
        var list = Array.prototype.slice.call(self._thumbs);
        var i = list.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
        if (i < 0) { i = list.length - 1; }
        if (i >= list.length) { i = 0; }
        list[i].focus();
        self.show(list[i].getAttribute('data-thumb'));
      });

      /* v6.14: deslizar sobre la foto grande pasa de imagen, el gesto que
         todo el mundo intenta primero en movil. Solo lectura del gesto:
         el scroll vertical normal no se toca (passive + umbral dominante). */
      var stage = this._slides.length ? this._slides[0].parentNode : null;
      if (stage) {
        this._tx = 0; this._ty = 0;
        stage.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) { return; }
          self._tx = e.touches[0].clientX;
          self._ty = e.touches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (!e.changedTouches || !e.changedTouches.length) { return; }
          var dx = e.changedTouches[0].clientX - self._tx;
          var dy = e.changedTouches[0].clientY - self._ty;
          if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.4) { return; }
          self.step(dx < 0 ? 1 : -1);
        }, { passive: true });
      }
    },
    step: function (dir) {
      var list = Array.prototype.slice.call(this._slides);
      var current = -1;
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('is-active')) { current = i; break; }
      }
      var next = current + dir;
      if (next < 0) { next = list.length - 1; }
      if (next >= list.length) { next = 0; }
      this.show(list[next].getAttribute('data-slide'));
    },
    show: function (id) {
      for (var i = 0; i < this._slides.length; i++) {
        this._slides[i].classList.toggle('is-active', this._slides[i].getAttribute('data-slide') === id);
      }
      for (var j = 0; j < this._thumbs.length; j++) {
        this._thumbs[j].setAttribute('aria-current', this._thumbs[j].getAttribute('data-thumb') === id ? 'true' : 'false');
      }
    },
    disconnectedCallback: function () { this._on = false; }
  });

  /* ---------------------------------------------------------- variant pick */
  /* v6.15.3: dos marcados posibles, detectados una vez al conectar.

     NUEVO (sections/main-product.liquid): un grupo por opcion. Cada chip lleva
     [data-option-group] (1..3, la posicion de la opcion) y [data-option-value]
     (el valor). Pulsar un chip cambia SOLO esa opcion y la variante se
     recompone cruzando los valores elegidos contra los data-option1..3 que el
     <select> imprime en cada <option>.

     VIEJO (sections/kv-product-landing.liquid): un chip por variante con
     [data-variant]. Se mantiene tal cual: esa plantilla no se ha migrado, y
     romperla para arreglar la ficha no era el trato.

     En ambos casos el unico camino a la sincronizacion sigue siendo poner el
     id en el <select> y disparar 'change': de ahi cuelgan precio, foto,
     boton, barra pegajosa (aqui) y el aviso de stock (kivora-v691.js). */
  var KV_PICKABLE = '[data-option-group][data-option-value], [data-variant]';

  define('kv-variants', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      this._select = this.querySelector('[data-variant-select]');
      if (!this._select) { return; }
      this._byOption = !!this.querySelector('[data-option-group][data-option-value]');

      this.addEventListener('click', function (e) {
        var s = e.target.closest && e.target.closest(KV_PICKABLE);
        if (!s) { return; }
        e.preventDefault();
        self.choose(s);
      });

      /* v6.14: patron radiogroup completo - las flechas mueven foco y
         seleccion (el mismo gesto que ya tenia la galeria).
         v6.15.3: acotadas al grupo. Con dos opciones, recorrer todo el
         componente saltaba de Color a Size sin avisar; un radiogroup se
         recorre dentro de si mismo. */
      this.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') { return; }
        var s = e.target.closest && e.target.closest(KV_PICKABLE);
        if (!s) { return; }
        e.preventDefault();
        var scope = (self._byOption && s.parentNode) ? s.parentNode : self;
        var list = Array.prototype.slice.call(scope.querySelectorAll(KV_PICKABLE));
        var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        var i = list.indexOf(s) + dir;
        if (i < 0) { i = list.length - 1; }
        if (i >= list.length) { i = 0; }
        list[i].focus();
        self.choose(list[i]);
      });

      this._select.addEventListener('change', function () { self.sync(); });
      this.sync();
    },

    /* Los valores de opcion de una <option> del select, en orden. */
    values: function (opt) {
      var out = [];
      if (!opt) { return out; }
      for (var i = 1; i <= 3; i++) {
        var a = opt.getAttribute('data-option' + i);
        if (a === null) { break; }
        out.push(a);
      }
      return out;
    },

    choose: function (el) {
      if (el.hasAttribute('data-option-value')) { this.pick(el); }
      else { this.commit(el.getAttribute('data-variant')); }
    },

    commit: function (id) {
      if (!id) { return; }
      this._select.value = id;
      this._select.dispatchEvent(new Event('change', { bubbles: true }));
    },

    /* Cambia UNA opcion y recompone la variante. */
    pick: function (btn) {
      var pos = parseInt(btn.getAttribute('data-option-group'), 10);
      var val = btn.getAttribute('data-option-value');
      if (!pos || val === null) { return; }

      var want = this.values(this._select.options[this._select.selectedIndex]);
      want[pos - 1] = val;

      var opts = this._select.options;
      var exact = null, exactSold = null, partial = null, best = -1;
      for (var i = 0; i < opts.length; i++) {
        var vals = this.values(opts[i]);
        if (vals[pos - 1] !== val) { continue; }
        var sold = opts[i].getAttribute('data-sold') === 'true';
        var score = 0, all = true;
        for (var j = 0; j < want.length; j++) {
          if (vals[j] === want[j]) { score++; } else { all = false; }
        }
        if (all) {
          if (!sold) { exact = opts[i]; break; }
          if (!exactSold) { exactSold = opts[i]; }
        }
        if (!sold && score > best) { best = score; partial = opts[i]; }
      }

      /* Orden deliberado. Si la combinacion pedida EXISTE se respeta aunque
         este agotada (exactSold): el cliente pidio ese color y esa talla y se
         le dice la verdad con el boton en "Sold out", en vez de moverle la
         talla por detras. Solo cuando la combinacion no existe en el catalogo
         se cede en las demas opciones (partial) para no dejarlo atascado. */
      var chosen = exact || exactSold || partial;
      if (!chosen) { return; }
      this.commit(chosen.value);
    },

    sync: function () {
      var chosen = this._select.options[this._select.selectedIndex];
      if (this._byOption) {
        var vals = this.values(chosen);
        var btns = this.querySelectorAll('[data-option-group][data-option-value]');
        for (var b = 0; b < btns.length; b++) {
          var pos = parseInt(btns[b].getAttribute('data-option-group'), 10);
          var on = vals[pos - 1] === btns[b].getAttribute('data-option-value');
          btns[b].setAttribute('aria-checked', on ? 'true' : 'false');
          /* v6.14: tabindex rotatorio - Tab entra al grupo una vez, no N. */
          if (btns[b].hasAttribute('tabindex')) { btns[b].setAttribute('tabindex', on ? '0' : '-1'); }
        }
      } else {
        var id = this._select.value;
        var flat = this.querySelectorAll('[data-variant]');
        for (var i = 0; i < flat.length; i++) {
          var hit = flat[i].getAttribute('data-variant') === id;
          flat[i].setAttribute('aria-checked', hit ? 'true' : 'false');
          if (flat[i].hasAttribute('tabindex')) { flat[i].setAttribute('tabindex', hit ? '0' : '-1'); }
        }
      }
      if (!chosen) { return; }
      /* v6.9.5: el precio puede imprimirse fuera de <kv-variants> (encima del
         bloque de compra), asi que se actualizan TODOS los nodos de precio de
         la seccion, no solo el que viva dentro del componente. */
      if (chosen.getAttribute('data-price')) {
        var scope = this.closest('.shopify-section') || document;
        var prices = scope.querySelectorAll('[data-variant-price]');
        for (var p = 0; p < prices.length; p++) { prices[p].innerHTML = chosen.getAttribute('data-price'); }
      }
      var media = chosen.getAttribute('data-media');
      if (media) {
        /* v6.14: acotado a la seccion. Con dos bloques de compra en la misma
           pagina, cambiar la variante del segundo cambiaba la foto del
           primero (todo lo demas de sync() ya estaba acotado desde v6.9.5). */
        var scopeG = this.closest('.shopify-section') || document;
        var gal = scopeG.querySelector('kv-gallery');
        if (gal && gal.show) { gal.show(media); }
      }
      var sold = chosen.getAttribute('data-sold') === 'true';
      var btn = this.querySelector('[data-add]');
      if (btn) {
        btn.disabled = sold;
        var label = btn.querySelector('.kv-btn__text');
        if (label) { label.textContent = sold ? (btn.getAttribute('data-sold-label') || 'Sold out') : (btn.getAttribute('data-add-label') || 'Add to cart'); }
      }
      /* v6.14: la barra pegajosa envia el MISMO formulario via form="...",
         pero vive fuera de <kv-variants>: con la variante agotada seguia
         diciendo "Add to cart" y enviando (422 invisible). Se sincroniza
         cualquier boton externo apuntando a este formulario. */
      /* v6.15.3: getAttribute('id'), NO .id. El formulario contiene
         <select name="id">, y el getter de controles con nombre de
         HTMLFormElement pisa la propiedad id nativa: form.id devolvia el
         propio <select>, la cadena quedaba en "[object HTMLSelectElement]" y
         el querySelectorAll no encontraba nada. Resultado: el arreglo de
         v6.14 nunca llego a correr en la ficha y la barra pegajosa seguia
         diciendo "Add to cart" con la variante agotada. */
      var ownerForm = (btn && btn.form) || this._select.form;
      var formId = ownerForm ? ownerForm.getAttribute('id') : null;
      if (formId) {
        var scopeB = this.closest('.shopify-section') || document;
        var extern = scopeB.querySelectorAll('button[form="' + formId + '"][type="submit"]');
        for (var x = 0; x < extern.length; x++) {
          if (extern[x] === btn) { continue; }
          extern[x].disabled = sold;
          var xl = extern[x].querySelector('.kv-btn__text') || extern[x];
          if (sold) {
            if (!extern[x]._kvLabel) { extern[x]._kvLabel = xl.textContent; }
            xl.textContent = extern[x].getAttribute('data-sold-label') || 'Sold out';
          } else if (extern[x]._kvLabel) {
            xl.textContent = extern[x]._kvLabel;
          }
        }
      }
    },
    disconnectedCallback: function () { this._on = false; }
  });

  /* ------------------------------------------------------------ sticky bar */
  define('kv-stickybar', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      /* v6.14: primero el centinela de la propia seccion; con dos bloques de
         compra en una pagina, todas las barras observaban el primero. */
      var scope = this.closest('.shopify-section') || document;
      var watch = scope.querySelector('[data-sticky-watch]') || document.querySelector('[data-sticky-watch]');
      if (!watch || !('IntersectionObserver' in window)) { return; }
      this._io = new IntersectionObserver(function (e) {
        self.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      this._io.observe(watch);
    },
    disconnectedCallback: function () {
      if (this._io) { this._io.disconnect(); }
      this._on = false;
    }
  });

  /* ------------------------------------------------------- add to cart ux */
  /* One delegated listener for every add-to-cart form on the page. The form
     still posts natively; this only shows that it is working and refuses a
     second submit from an impatient double click. The button is never given
     the disabled attribute, because a disabled submit button is dropped from
     the payload and Shopify would lose the value it was clicked with. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) { return; }
    if (form.getAttribute('data-kv-busy') === '1') { e.preventDefault(); return; }
    form.setAttribute('data-kv-busy', '1');
    /* v6.14: el boton pulsado puede vivir fuera del form (atributo form="id",
       como los CTA de kv-adpack): e.submitter es la verdad; el querySelector
       dentro del form era ciego a esos botones y su spinner nunca giraba. */
    var btn = (e.submitter && e.submitter.hasAttribute && e.submitter.hasAttribute('data-add')) ? e.submitter : form.querySelector('[data-add]');
    if (!btn && form.id) { btn = document.querySelector('[data-add][form="' + form.id + '"]'); }
    form._kvBtn = btn;
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
    /* If the navigation is cancelled or the visitor comes back through the
       history cache, the form has to be usable again. */
    /* v6.14: el handle se guarda en el formulario para que kivora-v6120.js
       lo cancele al resolver su fetch; el timer huerfano de un alta anterior
       apagaba el spinner de un alta posterior aun en vuelo. */
    if (form._kvT) { window.clearTimeout(form._kvT); }
    form._kvT = window.setTimeout(function () {
      form._kvT = null;
      form.removeAttribute('data-kv-busy');
      if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); }
    }, 8000);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    var forms = document.querySelectorAll('form[data-kv-busy]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].removeAttribute('data-kv-busy');
      var b = forms[i].querySelector('[data-add]');
      if (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-disabled'); }
    }
  });

  /* --------------------------------------------------------- recently seen */
  var KEY = 'kivora:recent';
  function recentRead() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); }
    catch (err) { return []; }
  }
  function recentWrite(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); }
    catch (err) { /* private mode: recently viewed simply does not persist */ }
  }
  define('kv-seen-record', {
    connectedCallback: function () {
      var h = this.getAttribute('data-handle');
      if (!h) { return; }
      var list = recentRead().filter(function (x) { return x !== h; });
      list.unshift(h);
      recentWrite(list);
    }
  });

  define('kv-seen-list', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      var exclude = this.getAttribute('data-exclude') || '';
      var limit = parseInt(this.getAttribute('data-limit'), 10) || 4;
      var fmt = this.getAttribute('data-money') || '${{amount}}';
      var KV_HANDLE_RE = /^[a-z0-9][a-z0-9_-]*$/i;
      var handles = recentRead().filter(function (h) {
        return typeof h === 'string' && h !== exclude && h.length < 256 && KV_HANDLE_RE.test(h);
      }).slice(0, limit);
      if (!handles.length) { return; }

      var run = function () {
        Promise.all(handles.map(function (h) {
          return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'products/' + encodeURIComponent(h) + '.js'
            : '/products/' + encodeURIComponent(h) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })).then(function (items) {
          var good = items.filter(Boolean);
          if (!good.length) { return; }
          var ul = self.querySelector('[data-seen-grid]');
          if (!ul) { return; }
          /* v6.11.2: misma tarjeta kv-pcard que el resto del catalogo (foto
             4:3, nombre serif, precio, Add to cart + See it). El formulario
             envia nativo y lo cubre el listener delegado de add-to-cart de
             arriba. Todo texto y URL concatenados a HTML pasan por esc(). */
          var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root : '/';
          ul.innerHTML = good.map(function (p) {
            var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
            var v = null;
            if (p.variants && p.variants.length) {
              for (var vi = 0; vi < p.variants.length; vi++) {
                if (p.variants[vi].available) { v = p.variants[vi]; break; }
              }
              if (!v) { v = p.variants[0]; }
            }
            var actions;
            if (!p.available) {
              actions = '<button class="kv-pcard__add" type="button" disabled>Out of stock</button>';
            } else if (p.variants && p.variants.length > 1) {
              /* v6.14: misma politica que kv-card — con opciones reales, la
                 eleccion se hace en la ficha, no se decide por el cliente. */
              actions = '<a class="kv-pcard__add" href="' + esc(p.url) + '">Choose options</a>';
            } else if (v) {
              actions = '<form class="kv-pcard__form" method="post" action="' + esc(root) + 'cart/add">' +
                '<input type="hidden" name="id" value="' + esc(v.id) + '">' +
                '<input type="hidden" name="quantity" value="1">' +
                '<button class="kv-pcard__add" type="submit" name="add" data-add aria-label="Add ' + esc(p.title) + ' to cart">' +
                  '<span class="kv-btn__text">Add to cart</span><span class="kv-btn__spin"></span>' +
                '</button></form>';
            } else {
              actions = '<button class="kv-pcard__add" type="button" disabled>Out of stock</button>';
            }
            return '<li class="kv-card kv-pcard">' +
              '<div class="kv-pcard__imgwrap">' +
                '<a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
                (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="600" height="600">'
                     : '<span class="kv-pcard__ph"></span>') +
                '</a>' +
              '</div>' +
              '<div class="kv-pcard__body">' +
                '<h3 class="kv-pcard__name"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
                '<div class="kv-pcard__prices"><span class="kv-pcard__now">' + money(p.price, fmt) + '</span></div>' +
                '<div class="kv-pcard__actions">' + actions +
                  '<a class="kv-pcard__see" href="' + esc(p.url) + '">View details<span class="kv-sr"> for ' + esc(p.title) + '</span></a>' +
                '</div>' +
              '</div>' +
            '</li>';
          }).join('');
          self.hidden = false;
        });
      };

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (e) {
          if (e[0].isIntersecting) { self._io.disconnect(); run(); }
        }, { rootMargin: '400px' });
        this._io.observe(this);
      } else { run(); }
    },
    disconnectedCallback: function () {
      if (this._io) { this._io.disconnect(); }
      this._on = false;
    }
  });

  /* ------------------------------------------------------------- carousel */
  /* Horizontal scroller. The row already scrolls natively with touch and with
     the keyboard, so this only adds the desktop arrows and keeps their state
     honest. If this never runs, the arrows stay hidden and nothing is lost. */
  define('kv-carousel', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      var track = this.querySelector('[data-carousel-track]');
      var prev = this.querySelector('[data-carousel-prev]');
      var next = this.querySelector('[data-carousel-next]');
      if (!track) { return; }
      this._track = track;

      var reduced = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
        : false;

      this._step = function () {
        var first = track.querySelector('li');
        var w = first ? first.getBoundingClientRect().width : 180;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || '24') || 24;
        var per = Math.max(1, Math.floor(track.clientWidth / (w + gap)) - 1);
        return (w + gap) * per;
      };

      this._sync = function () {
        var overflow = track.scrollWidth - track.clientWidth > 4;
        if (prev) { prev.hidden = !overflow; prev.disabled = track.scrollLeft <= 2; }
        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2);
        }
      };

      this._go = function (dir) {
        var x = track.scrollLeft + dir * self._step();
        if (reduced || !('scrollBehavior' in document.documentElement.style)) {
          track.scrollLeft = x;
        } else {
          track.scrollTo({ left: x, behavior: 'smooth' });
        }
      };

      if (prev) { prev.addEventListener('click', function () { self._go(-1); }); }
      if (next) { next.addEventListener('click', function () { self._go(1); }); }

      /* Arrow keys move the row when the track itself has focus. */
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self._go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self._go(-1); }
        else if (e.key === 'Home') { e.preventDefault(); track.scrollLeft = 0; }
        else if (e.key === 'End') { e.preventDefault(); track.scrollLeft = track.scrollWidth; }
      });

      /* v6.9.5: el scroll dispara _sync como mucho una vez por frame. */
      this._raf = null;
      this._onScroll = function () {
        if (self._raf) { return; }
        self._raf = window.requestAnimationFrame(function () {
          self._raf = null;
          self._sync();
        });
      };
      track.addEventListener('scroll', this._onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(function () { self._sync(); });
        this._ro.observe(track);
      } else {
        this._onResize = function () { self._sync(); };
        window.addEventListener('resize', this._onResize);
      }
      this._sync();
    },
    disconnectedCallback: function () {
      if (this._track && this._onScroll) { this._track.removeEventListener('scroll', this._onScroll); }
      /* v6.9.5: se cancela el frame pendiente si lo hubiera. */
      if (this._raf) { window.cancelAnimationFrame(this._raf); this._raf = null; }
      if (this._ro) { this._ro.disconnect(); }
      if (this._onResize) { window.removeEventListener('resize', this._onResize); }
      this._ro = null; this._track = null; this._on = false;
    }
  });

  /* -------------------------------------------------------------- marquee */
  /* Continuous product ribbon. The movement itself is a CSS keyframe, so this
     runs no code per frame. All it does is duplicate the row once so the loop
     has something seamless to repeat, hide the duplicate from assistive
     technology, and decide whether automatic movement is appropriate at all.

     Automatic movement is only appropriate where there is a pointer that can
     hover, because that is the only way to pause it. On touch, and whenever
     reduced motion is asked for, the same markup stays an ordinary scroll
     container that can be swiped and dragged. */
  define('kv-marquee', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      var track = this.querySelector('[data-marquee-track]');
      var mask = this.querySelector('[data-marquee-mask]');
      if (!track || !mask) { return; }
      this._track = track;
      this._mask = mask;
      this._cloned = false;

      var speed = parseFloat(this.getAttribute('data-speed'));
      if (!speed || speed < 10) { speed = 46; }
      this.style.setProperty('--kv-speed', speed + 's');

      this._canAuto = function () {
        if (reduce || design) { return false; }
        if (!window.matchMedia) { return false; }
        if (!window.matchMedia('(hover: hover)').matches) { return false; }
        /* Duplicating is what allows the loop, and also what makes the same
           product appear twice. It only pays off once the row is at least twice
           the width of the window: below that the copy shares the screen with
           the original and reads as a bug. */
        return track.scrollWidth >= mask.clientWidth * 2;
      };

      this._clone = function () {
        if (self._cloned) { return; }
        var items = track.children;
        var n = items.length;
        if (!n) { return; }
        /* Reveal the originals first: the clones inherit their classes, and a
           clone is never observed, so anything still waiting would be copied
           in its hidden state and stay invisible forever. */
        var hidden = track.querySelectorAll(HIDDEN);
        for (var h = 0; h < hidden.length; h++) { hidden[h].classList.add('is-in'); }
        var frag = document.createDocumentFragment();
        for (var i = 0; i < n; i++) {
          var copy = items[i].cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('id');
          /* A screen reader must not meet the same product twice, and tab order
             must not walk through a decorative repeat. */
          var f = copy.querySelectorAll('a, button, input, select, textarea, [tabindex]');
          for (var j = 0; j < f.length; j++) {
            f[j].setAttribute('tabindex', '-1');
            f[j].removeAttribute('id');
          }
          frag.appendChild(copy);
        }
        track.appendChild(frag);
        self._cloned = true;
      };

      this._sync = function () {
        if (self._canAuto()) {
          self._clone();
          self.classList.add('is-running');
          mask.removeAttribute('tabindex');
        } else {
          self.classList.remove('is-running');
          /* As a plain scroller it has to be reachable from the keyboard. */
          if (track.scrollWidth > mask.clientWidth + 8) { mask.setAttribute('tabindex', '0'); }
          else { mask.removeAttribute('tabindex'); }
        }
      };

      /* Pause while a finger is on it, on the hybrid devices that both hover
         and touch. Hover and focus pausing are handled in CSS. */
      this._hold = function () { self.classList.add('is-held'); };
      this._release = function () { self.classList.remove('is-held'); };
      this.addEventListener('touchstart', this._hold, { passive: true });
      this.addEventListener('touchend', this._release, { passive: true });
      this.addEventListener('touchcancel', this._release, { passive: true });

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(function () { self._sync(); });
        this._ro.observe(mask);
      } else {
        this._onResize = function () { self._sync(); };
        window.addEventListener('resize', this._onResize);
      }
      this._sync();
    },
    disconnectedCallback: function () {
      if (this._ro) { this._ro.disconnect(); }
      if (this._onResize) { window.removeEventListener('resize', this._onResize); }
      this.removeEventListener('touchstart', this._hold);
      this.removeEventListener('touchend', this._release);
      this.removeEventListener('touchcancel', this._release);
      this._ro = null; this._track = null; this._mask = null; this._on = false;
    }
  });

  /* ------------------------------------------------------------ image fade */
  /* Images arrive by decoding, not by layout, so without this they snap in one
     frame after the space around them has already settled. The hidden state is
     only ever applied to an image that has not finished loading, and only from
     JavaScript: if this never runs, nothing is hidden. Images inside a .kv-w
     are left alone, because their own reveal already handles them. */
  if (!reduce) {
    document.addEventListener('DOMContentLoaded', function () {
      var imgs = document.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        /* v6.14: las imagenes lazy quedan fuera: cuando por fin se descargan
           el timeout de 3s ya paso y no habia fade, solo el coste (30+
           listeners y timers en el arranque de una coleccion). */
        if (img.complete || img.loading === 'lazy' || img.closest('.kv-w')) { continue; }
        img.classList.add('is-loading');
        /* Safety net: an image that errors or stalls must not stay hidden. */
        (function (el) {
          var clear = function () { el.classList.remove('is-loading'); };
          el.addEventListener('load', clear, { once: true });
          el.addEventListener('error', clear, { once: true });
          window.setTimeout(clear, 3000);
        })(img);
      }
    });
  }

  /* ---------------------------------------------------- facet auto-submit */
  define('kv-facets', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var form = this.querySelector('form');
      if (!form) { return; }
      /* v6.14: el cajon de filtros con casillas multiples NO auto-envia:
         cada marca recargaba la pagina y cerraba el cajon, asi que aplicar
         tres filtros exigia tres recargas. El formulario marcado como manual
         conserva su boton "Apply filters"; la barra de orden sigue siendo
         instantanea. */
      if (form.hasAttribute('data-facet-manual')) { return; }
      var t = null;
      form.addEventListener('change', function () {
        if (t) { window.clearTimeout(t); }
        t = window.setTimeout(function () { form.submit(); }, 250);
      });
      var submit = form.querySelector('[data-facet-submit]');
      if (submit) { submit.hidden = true; }
    },
    disconnectedCallback: function () { this._on = false; }
  });

  /* --------------------------------------------------- announcement bar
     The dismissal is remembered against the message itself, not against a
     generic flag: change the wording and the bar comes back for everyone,
     instead of staying hidden forever for the people who closed the old one.
     In the theme editor it never hides, or the merchant would be writing a
     message into something they cannot see. */
  define('kv-announce', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;
      var key = 'kv-announce:' + (this.getAttribute('data-key') || '');
      var editing = document.documentElement.classList.contains('is-editor') ||
                    window.Shopify && window.Shopify.designMode;
      if (!editing) {
        try {
          if (window.localStorage.getItem(key) === '1') { this.hidden = true; return; }
        } catch (e) { /* almacenamiento bloqueado: la barra simplemente se queda */ }
      }
      var close = this.querySelector('[data-announce-close]');
      if (!close) { return; }
      this._close = function () {
        self.hidden = true;
        try { window.localStorage.setItem(key, '1'); } catch (e) {}
      };
      close.addEventListener('click', this._close);
    },
    disconnectedCallback: function () {
      this._on = false;
      var close = this.querySelector('[data-announce-close]');
      if (close && this._close) { close.removeEventListener('click', this._close); }
    }
  });
})();
